import { useRouter } from 'next/router';

export const useGetRouterQuerySlug = (): string | undefined => {
  const { query } = useRouter();
  const { slug } = query;

  return Array.isArray(slug) ? slug[0] : slug;
};
